import type { TenantAnalyticsConsentSnapshot } from '@kit/analytics/tenant';

import type {
  IosTrackingStatus,
  IosTrackingSupport,
} from '~/(tenant)/_lib/capacitor/app-tracking-transparency';

/**
 * In the iOS app, Apple's App Tracking Transparency answer is the only valid
 * permission for marketing tags (guideline 5.1.2). It applies only when the
 * tenant has a marketing tag to fire; then it replaces the stored banner
 * choice entirely, and an app build without the ATT plugin keeps everything
 * off. Everywhere else the stored banner choice stands.
 */
export function shouldAppTrackingGovernConsent(
  offersMarketing: boolean,
  support: IosTrackingSupport,
) {
  return offersMarketing && support !== 'not-ios';
}

export function resolveAppTrackingConsent(
  storedConsent: TenantAnalyticsConsentSnapshot,
  offersMarketing: boolean,
  support: IosTrackingSupport,
  status: IosTrackingStatus | null,
): TenantAnalyticsConsentSnapshot {
  if (!shouldAppTrackingGovernConsent(offersMarketing, support)) {
    return storedConsent;
  }

  const allowed = support === 'supported' && status === 'authorized';

  return { ...storedConsent, analytics: allowed, advertising: allowed };
}
